import { ISalariesSummaryRequest } from '../../interfaces/salaries-summary.interface'

export class GetSalariesSummary {
  static readonly type = '[SalariesSummary] Get Salaries Summary'
  constructor(public payload: ISalariesSummaryRequest) {}
}

export class ResetSalariesSummary {
  static readonly type = '[SalariesSummary] Reset Salaries Summary'
}
